import { IMasonryTile } from "./IMasonryTile";
import { ProductTile } from "./ProductList";

export interface SearchRequest {
  term: string | null;
  categories: Array<string> | null;
  selectedFacets: Record<string, Array<string | number | boolean>> | null;
  pageNo: number;
  totalPageSize: number;
  sorting: Sorting;
  requestFullResult: boolean;
  showOnlyAgreementProducts: boolean;
  contentId: string;
}

export interface ProductsSearchRequest {
  term: string;
  pageNo: number;
  totalPageSize: number;
  sorting: Sorting;
  requestFullResult: boolean;
  showOnlyAgreementProducts: boolean;
}

export interface Pagination {
  totalHits: number;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  pageSizeOptions: number[];
}

export interface SearchResponse {
  totalPages: number;
  tiles: Array<ProductTile>;
  facets: Array<FacetGroup>;
  facetNames: Record<string, string>;
  remainingProducts: number;
  totalHits: number;
  pagination: Pagination;
}

export interface ProductSearchResponse {
  totalPages: number;
  products: Array<ProductTile>;
  facets: Array<FacetGroup>;
  facetNames: Record<string, string>;
  remainingProducts: number;
  totalHits: number;
  pagination: Pagination;
}

export interface SearchCasesResponse {
  totalPages: number;
  casePages: Array<IMasonryTile>;
  facets: Array<Facet>;
  facetNames: Record<string, string>;
  remainingProducts: number;
  totalHits: number;
  pagination: Pagination;
}

export interface FacetGroup {
  key: string;
  available: Array<Facet>;
}

export interface Facet {
  key: string;
  available: FacetAvailable[];
  levels: FacetLevel[];
}

export interface FacetLevel {
  levelName: string;
  available: FacetAvailable[];
}

export interface FacetAvailable {
  value: string | boolean | number;
  encodedValue: string;
  hits: number;
  selected: boolean;
}

export enum Sorting {
  RelevanceDesc = "RelevanceDesc",
  RelevanceAsc = "RelevanceAsc",
  PopularityDesc = "PopularityDesc",
  PopularityAsc = "PopularityAsc",
  ListPriceDesc = "ListPriceDesc",
  ListPriceAsc = "ListPriceAsc",
}
